import LabeledInput from '../../../shared/components/labeled-input';
import LabeledTextarea from '../../../shared/components/labeled-textarea';
import OptionsDropdown from '../../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import React from 'react';

const newPartNumbertextChange = props => event => {

    props.changeTextNewPartNum( event );

};
const PGMAside = props => (
    <section>
        <div className="aside-section">
            <div className="top-section">
                <LabeledTextarea
                    className="input-name"
                    isEditable={true}
                    name="factoryCode"
                    label="Factory Code"
                    value={props.factoryDescription}
                    disabled={true}
                />
                <OptionsDropdown
                    className="input-name"
                    isPlaceholderTranslated={true}
                    name="productSeriesId"
                    label="Product Series"
                    optionDisplayAttributes={['productSeriesName']}
                    optionKey="productSeriesId"
                    options={props.productList}
                    placeholder=""
                    onChange={props.onTextChange.bind( this )}
                    selectedValue={props.selectedPartGroup.productSeriesId}
                    disabled={!props.isAddNew}
                    isRequired={true}
                />
                <LabeledInput
                    className="input-name partReqdField"
                    isEditable={true}
                    name="partGroupName"
                    label="Part Group"
                    maxLength={6}
                    onChange={props.onTextChange.bind( this )}
                    value={props.selectedPartGroup.partGroupName}
                    isRequired={true}
                />
                <LabeledTextarea
                    className="input-name"
                    isEditable={true}
                    name="partGroupDescription"
                    label="Part Group Description"
                    maxLength={35}
                    onChange={props.onTextChange.bind( this )}
                    value={props.selectedPartGroup.partGroupDescription}
                />
            </div>
            <div className="bottom-section">
                <LabeledInput
                    className="input-name reqdField"
                    isEditable={true}
                    name="partNumber"
                    label="Corrected Part Number"
                    maxLength={12}
                    onChange={props.onTextChange.bind( this )}
                    value={props.selectedPartGroup.partNumber}
                    disabled={!props.isAddNew}
                    isRequired={true}
                />
                <LabeledTextarea
                    className="input-name"
                    isEditable={true}
                    name="partNumberDescription"
                    label="Corrected Part Description"
                    maxLength={50}
                    onChange={props.onTextChange.bind( this )}
                    value={props.selectedPartGroup.partNumberDescription}
                />
            </div>
        </div>
        <div className="button-section">
            {!props.isAddNew && (
                <div className="button-align">
                    <div className={`button-div ${props.isOpen ? 'disabled' : ''}`}>
                        <button className={`button-cls ${!props.isOpen ? 'delete-active' : ''}`} type="button" onClick={props.onDelete}>Delete</button>
                        <button className={`button-cls ${!props.isOpen ? 'active' : ''}`} type="button" onClick={props.onUpdate}>Update</button>
                    </div>

                    <div className="add-new-part-num-section">
                        <span className={`add-new-part-num-header ${props.isOpen ? 'hide' : ''}`} onClick={props.handleOpenAddNewSection}>
                            <i className="fa fa-plus-circle" />
                            Add New Part Number to this Group
                        </span>
                        <div className={`add-new-bottom-section ${props.isOpen ? 'show' : ''}`}>
                            <LabeledInput
                                className="input-name"
                                isEditable={true}
                                name="newPartNumText"
                                label="Corrected Part Number"
                                maxLength={12}
                                onChange={newPartNumbertextChange( props )}
                                newPartNumText={props.newPartNumText}
                                value={props.newPartNumText}
                            />
                            <LabeledTextarea
                                className="input-name"
                                isEditable={true}
                                name="newPartDescext"
                                label="Corrected Part Description"
                                maxLength={50}
                                onChange={newPartNumbertextChange( props )}
                                value={props.newPartDescext}
                            />

                            <div className="button-align">
                                <button className="close-botton" type="button" onClick={props.handleCloseAddNewSection}>Cancel</button>
                                <div className="disabled-div">
                                    <button type="button" className={`button-cls ${props.newPartNumText ? 'active' : ''}`} onClick={props.handleaddNewPartNumToGroup}>
                                        Add new
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {props.isAddNew && (
                <div className="button-align">
                    <button className="close-button" type="button" onClick={props.onCancel}>Cancel</button>
                    <button
                        className="primary-button"
                        type="button"
                        onClick={props.OnAddNew}
                        disabled={!( ( props.selectedPartGroup.productSeriesId !== undefined && props.selectedPartGroup.productSeriesId !== '-1' )
                    && ( props.selectedPartGroup.partGroupName !== undefined && ( props.selectedPartGroup.partGroupName ).trim() !== '' )
                    && ( props.selectedPartGroup.partNumber !== undefined && ( props.selectedPartGroup.partNumber ).trim() !== '' )
                        )}
                    >
Add New
                    </button>
                </div>
            )}
        </div>
    </section>
);
PGMAside.displayName = 'PGMAside';
PGMAside.propTypes = {
    productList: PropTypes.array.isRequired,
    selectedPartGroup: PropTypes.object.isRequired,
    newPartNumText: PropTypes.string.isRequired,
    newPartDescext: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    isAddNew: PropTypes.bool.isRequired,
    factoryDescription: PropTypes.string.isRequired,
    onTextChange: PropTypes.func.isRequired,
    handleOpenAddNewSection: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    OnAddNew: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    handleaddNewPartNumToGroup: PropTypes.func.isRequired,
    handleCloseAddNewSection: PropTypes.func.isRequired,
};
export default PGMAside;
